import TopicButtonController from "./topic-button-controller";
import { connect } from "react-redux";
import { getValue } from "store/languages"
import { getTopics } from "selectors/theme-selector";
import { setStartDate, setEndDate, setGrouping, setDateChanged, setGroupingByPeriod } from "store/calendar";
import { setSelectedMyFilterMenu, setMySelectedFilter, setMySelectedTopicsFilter, filtersChanged } from "store/filters"
import { getSelectedTopicsUUID, getSelectedSubTopicsUUID } from "selectors/topic-menu-selector"
import { setReturnBackFilters, setReturnBackPageName, setIsReturnedBack } from "store/return-back-button";
import HeaderButtons from 'assets/header-buttons/header-buttons'
import { setSelectedMenu, setSettingsMenuToNull } from "store/settings-menu"

let mapStateToProps = (state) => {

    return {
        postsCount: state.storage.storageData.numFoundTotal,
        selectedTopics: getSelectedTopicsUUID(state),
        selectedSubtopics: getSelectedSubTopicsUUID(state),
        selectedUUId: state.Tree.selectedUUId,
        selectedSubUUId: state.Tree.selectedSubUUId,
        settingsMenuItems: state.settingsPageMenu.items,
        topicData: getTopics(state),
        pageCurrentName: state.Filters.pageName,
        pageName: state.ReturnBack.pageName,
        grouping: state.ReturnBack.grouping,
        filters: state.ReturnBack.filters,
        menuSelected: state.ReturnBack.menuSelected,
        isReturnedBack: state.ReturnBack.isReturnedBack,
        docsCount: state.ReturnBack.docsCount,
        headerButtons: HeaderButtons,
        selectedUUId: state.Tree.selectedUUId,
        selectedTopicsF: state.Filters.selectedTopics,
        selectedLanguage: state.languages.selectedLanguage,
        deviceType: state.header.deviceType
    }
}

const TopicButtonContainer = connect(mapStateToProps, {getValue, setStartDate, setEndDate, setGrouping, setMySelectedFilter, setMySelectedTopicsFilter, setSelectedMenu, setSettingsMenuToNull, filtersChanged, setReturnBackFilters, setReturnBackPageName, setIsReturnedBack})(TopicButtonController);
export default TopicButtonContainer
